import { render, staticRenderFns } from "./UserSocialSelfiesData.vue?vue&type=template&id=31808685&"
import script from "./UserSocialSelfiesData.vue?vue&type=script&lang=js&"
export * from "./UserSocialSelfiesData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31808685')) {
      api.createRecord('31808685', component.options)
    } else {
      api.reload('31808685', component.options)
    }
    module.hot.accept("./UserSocialSelfiesData.vue?vue&type=template&id=31808685&", function () {
      api.rerender('31808685', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/Reports/UserSocialSelfiesData.vue"
export default component.exports